/* eslint-disable object-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
import axios from 'axios';
import { Mutex } from 'async-mutex';
import { httpOnlySecurityService } from '../externals/iam';
import { getProperty } from '../services/PropertiesService';

const { get: axiosGet, post: axiosPost, put: axiosPut, delete: axiosDelete, patch: axiosPatch } = axios;

const onSuccess = (response) => response.data;

const onError = (error) => Promise.reject(error.response || error.message);

export const get = (...args) =>
  axiosGet(...args)
    .then(onSuccess)
    .catch(onError);

export const put = (...args) =>
  axiosPut(...args)
    .then(onSuccess)
    .catch(onError);

export const post = (...args) =>
  axiosPost(...args)
    .then(onSuccess)
    .catch(onError);

export const destroy = (...args) =>
  axiosDelete(...args)
    .then(onSuccess)
    .catch(onError);

export const patch = (...args) =>
  axiosPatch(...args)
    .then(onSuccess)
    .catch(onError);

axios.defaults.withCredentials = true;

const mutex = new Mutex();
let refreshFailed = false;

async function refreshToken() {
  const release = await mutex.acquire();
  if (refreshFailed) {
    throw new axios.Cancel('Refresh token failed');
  }
  try {
    await httpOnlySecurityService.refresh();
  } catch (error) {
    refreshFailed = true;
    httpOnlySecurityService.login(window.location.href);
    throw new axios.Cancel('Refresh token failed');
  } finally {
    release();
  }
}

axios.interceptors.request.use(async (config) => {
  if (httpOnlySecurityService.isTokenExpired()) {
    if (refreshFailed) {
      throw new axios.Cancel('Refresh token failed');
    }
    await refreshToken();
  }

  return config;
});

function errorUnauthorised() {
  httpOnlySecurityService.clear();
  window.location.href = `${getProperty('REACT_APP_FRONT_END_URL')}/#/en/login`;
}

function errorAccessDenied(error, reject) {
  if (
    error.response.headers['www-authenticate'] &&
    error.response.headers['www-authenticate'] === 'illegal_configuration'
  ) {
    const configError = new Error('GET_USER_INFO_ERROR');

    reject(configError);
  }
  reject(error);
}

function processError(error) {
  return new Promise((resolve, reject) => {
    if (error.response.status === 401) {
      const header = error.response.headers['www-authenticate'];
      if (header === 'access_expired') {
        (async () => {
          await refreshToken();
        })();
      } else errorUnauthorised();
    } else if (error.response.status === 403) {
      errorAccessDenied(error, reject);
    } else {
      reject(error);
    }
  });
}

axios.interceptors.response.use((response) => response, processError);

export const formatRequestParams = (options) => {
  const sortParams = !!options.sortField && { sortField: options.sortField, direction: options.sortDirection };
  const searchParams = options.searchField && options.searchTerm && { [options.searchField]: options.searchTerm };
  const pagination = options.page && options.size ? { page: options.page, size: options.size } : {};
  const requestContext = !!options.requestContext && { requestContext: options.requestContext };

  return {
    params: {
      ...pagination,
      ...sortParams,
      ...searchParams,
      ...requestContext,
    },
  };
};
